import React, { Component } from 'react';
import { Row, Col, Container, Form, Button } from 'react-bootstrap';
import axios from 'axios';

class Support extends Component {

    state={
        name: "",
        email: "",
        subject: "",
        message: "",
        terms: false,
        formCompleted: true,
        emailSended: false
    };

    termsHandler = (e) => {
        if (e.target.value === "false") {
            this.setState({
                terms: true
            });
        } else {
            this.setState({
                terms: false
            });
        }
    }

    textHandler = (e) => {
        e.preventDefault();
        this.setState({
            [e.target.id] : e.target.value
        });
    }

    subbitHandler = (e) => {
        e.preventDefault();
        // console.log("Send Form, state: ", this.state);
        if(this.state.name !== "" && this.state.email !== "" && this.state.subject !== "" && this.state.message !== "" && this.state.terms === true) {
            // Set ready to send
            this.setState({
                formCompleted: true
            });
            // send form via Axios API
            console.log("Sending Form...");

            const data_send = { // Con axios invia automaticamente i dati in formato JSON al server non cè bisogno di usare => JSON.stringify()
                name: this.state.name,
                email: this.state.email,
                subject: this.state.subject,
                message: this.state.message
            };

            const self = this;
            axios.post('https://www.tuunes.co/api/SendEmailWallpaper/', data_send)
                .then(function (response) {
                    console.log("Email Server Response: ", response.data);
                    self.resetHandler();
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            this.setState({
                formCompleted: false
            });
        }
    }

    resetHandler = () => {
        this.setState({
            emailSended: true
        });
        let element = document.getElementById("accept-terms");
        // Resetta lo State in x secondi con un timer
        setTimeout(() => {
            this.setState({
                name: "",
                email: "",
                subject: "",
                message: "",
                terms: false,
                formCompleted: true,
                emailSended: false
            });
            // Deselect Accet terms and conditions
            element.checked = false;
            
            
        }, 3000);
    }

    render() {

        let errorMsg = null;
        if (this.state.formCompleted === false) {
            errorMsg = <p style={{ display: 'block', color: 'red' }}>· Please complete all fields correctly before submitting your request.</p>;
        }else if (this.state.emailSended === true) {
            errorMsg = <p style={{ display: 'block', color: 'green' }}>· <b>Your request has been sent correctly.</b> Thank you for contacting us, we will reply in the next few days.</p>;
        }

        return (
            <Container>
                <Row>
                    <Col xs={12} sm={12}>
                        <br />
                        <h3>Support</h3>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12}>
                        <p>In case you have any questions or interest to work with us please provide some details in order to get back to you.</p>
                        <br />
                        <Form onSubmit={this.subbitHandler}>
                            <Form.Group controlId="name">
                                <Form.Label>Your Name</Form.Label>
                                <Form.Control type="text" placeholder="First and Last Name" value={this.state.name} onChange={this.textHandler} />
                            </Form.Group>
                            <Form.Group controlId="email">
                                <Form.Label>Your Email</Form.Label>
                                <Form.Control type="email" placeholder="name@example.com" value={this.state.email} onChange={this.textHandler} />
                            </Form.Group>
                            <Form.Group controlId="subject">
                                <Form.Label>Subject</Form.Label>
                                <Form.Control type="text" placeholder="" value={this.state.subject} onChange={this.textHandler} />
                            </Form.Group>
                            <Form.Group controlId="message">
                                <Form.Label>Your Message</Form.Label>
                                <Form.Control as="textarea" rows="5" value={this.state.message} onChange={this.textHandler} />
                            </Form.Group>
                            <label className="form-check" htmlFor="accept-terms">
                                <input className="form-check-input" id="accept-terms" type="checkbox" name="accept-terms" required value={`${this.state.terms}`} onChange={this.termsHandler} />
                                <i className="fa fa-square-o fa-2x"></i>
                                <i className="fa fa-check-square-o fa-2x"></i>
                                <span> I agree to the <a href='/terms-conditions' target='_blank'>Terms & Conditions</a></span>
                            </label>
                            {errorMsg}
                            <br />
                            <Button variant="primary" type="submit">Request Support</Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
    
}

export default Support;